// extracted by mini-css-extract-plugin
module.exports = {"container":"_472c981","title":"_549c323","subtitle":"_1db7d55"};